module.exports = __webpack_public_path__ + "80a81f612334fdaa90a7f0790ddc23e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mega-menu-bg.png
// module id = 1070
// module chunks = 1